import { Col, Row } from 'react-bootstrap';

import CTCPIMAGE from 'assets/img/icons/logotipo-horizontal-ctcp.svg';
import CTCPIMAGEDARK from 'assets/img/icons/logotipo-horizontal-ctcp.svg';

const Homepage = () => {
  return (
    <div>
      <div className="px-3">
        <Row className="min-vh-75 flex-center p-5">
          <Col xs={12} xl={10} xxl={8}>
            <Row className="justify-content-center align-items-center g-5">
              <Col xs={12} lg={6} className="text-center order-lg-1">
                <img
                  src={CTCPIMAGE}
                  alt=""
                  width={400}
                  className="img-fluid w-lg-100 d-dark-none"
                />
                <img
                  src={CTCPIMAGEDARK}
                  alt=""
                  width={540}
                  className="img-fluid w-md-50 w-lg-100 d-light-none"
                />
              </Col>
              {/* <Col xs={12} lg={6} className="text-center text-lg-start">
                <h1 className="text-body-secondary fw-bolder mb-3">
                  Bem vindo ao novo site de gestão do
                </h1>
                // <p className="text-body mb-5">
                //   You don’t have permission to access this resource.
                // </p> 
              </Col> */}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Homepage;
